<template>
  <div>
    <van-cell
      :value="item.value + '分'"
      is-link
      class="mytab mytabTT"
      center
      v-for="(item, index) in list"
      :key="index"
      @click="handClickLink(item)"
    >
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <div class="pointImgcomment1">
          <img :src="require(`@/assets/image/anxin/${item.name}.png`)" v-if="item.name !== '微量元素'"/>
          <img v-else  src="../../../assets/image/anxin/蛋白质代谢功能.png"/>
          <div>
            <span class="span1"> {{ item.name }} </span>
            <b
              :style="{
                color:
                  item.status == '差'
                    ? '#D45353'
                    : item.status == '中'
                    ? '#F1BE33'
                    : item.status == '良'
                    ? '#9EF133'
                    : '#28D200',
              }"
            >
              ({{ item.status }})
            </b>
            <br />
            <span class="span2"> <i v-text="item.gs"> </i>项异常 </span>
          </div>
        </div>
      </template>
    </van-cell>
  </div>
</template>
<script>
import markbox from "./markBox.vue"
export default {
  props: ['list', 'laiyuan'],
  components: {
    markbox
  },
  data () {
    return {
      activeNames: [],

    }
  },
  watch: {
    list (newVal) {

      this.list = newVal;
    }
  },
  methods: {
    handClickLink (item) {
      console.log(item)
      if (this.laiyuan == 'offLink') {

        this.$router.push({ path: '/peaceSystemContentOld', query: { row: encodeURIComponent(JSON.stringify(item)) } });
      } else {
        this.$router.push({ path: '/peaceSystemOld', query: { row: encodeURIComponent(JSON.stringify(item)) } });
      }

    }
  }
}
</script>
<style lang="scss" scoped>
.mytab {
  box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.1);
  border-radius: 10px;
  overflow: hidden;
}
.pointImgcomment1 {
  display: flex;
  img {
    width: 65px;
    height: 65px;
    vertical-align: middle;
    margin-right: 20px;
  }
  .span1 {
    font-size: 26px;
    vertical-align: middle;
    display: inline-block;
  }
  b {
    font-weight: 400;
    font-size: 26px;
  }
  div {
    flex: 1;
  }
  .span2 {
    font-size: 22px;
    display: inline-block;
    margin-top: 10px;
    i {
      color: #d45353;
      margin-right: 5px;
    }
  }
}
</style>